import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from "src/app/material.module";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SideNavComponent } from './side-nav/side-nav.component';
import * as PlotlyJS from 'plotly.js/dist/plotly.js';
import { PlotlyModule } from 'angular-plotly.js';
import { AgmCoreModule } from '@agm/core';
import { IndividualDashboardComponent } from './individual-dashboard/individual-dashboard.component';
import { DashboardService } from './services/dashboard.service';
import { SseService } from './services/sse.service';
import { LoginService } from './services/login.service';
import { GlobalService } from './services/global.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { UserComponent } from './user/user.component';
import { AddEditUserComponent } from './add-edit-user/add-edit-user.component';
import { ApiInterceptor } from './api-interceptor';
import { AuthGuard } from './auth.guard';
import { NgxUiLoaderModule,NgxUiLoaderService,NgxUiLoaderRouterModule} from 'ngx-ui-loader';
import { SiteManagerComponent } from './site-manager/site-manager.component';
import { AddEditSiteManagerComponent } from './add-edit-site-manager/add-edit-site-manager.component';
import { SiteManagerService } from './services/site-manager.service';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { DemandTrendAnalysisComponent } from './demand-trend-analysis/demand-trend-analysis.component';
import { DemandTrendAnalysisAvailabilityComponent } from './demand-trend-analysis-availability/demand-trend-analysis-availability.component';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { ConfirmationDailogComponent } from './confirmation-dailog/confirmation-dailog.component';
import { ToastrModule } from 'ngx-toastr';
import { TransfomerManagerComponent } from './transformer/transformer-manager/transfomer-manager.component';
import { AddTransformerComponent } from './transformer/add-transformer/add-transformer.component';
import { MatFormFieldDefaultOptions, MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material';
import { DeviceManagerComponent } from './device/device-master/devicemaster.component';
import { AddDeviceComponent } from './device/add-device/add-device.component';
import { DeviceMasterService } from './services/device-master.service';
import { ReportComponent } from './reports/report.component';
import { ReportService } from './services/report.service';
import { AlertReportComponent } from './reports/alert/alert-report.component';
import { CustomDateComponent } from './reports/customdate/custom-date.component';
import { AlertComponent } from './alert/alert.component';
import { AccessAuthGuard } from './access-auth.guard';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { GaugeChartModule } from 'angular-gauge-chart';
import { CircularGaugeModule } from '@syncfusion/ej2-angular-circulargauge';
import { GradientService } from '@syncfusion/ej2-angular-circulargauge';
import { OnlineofflinereportComponent } from './reports/onlineofflinereport/onlineofflinereport.component';
import { OnlineofflineanalysisComponent } from './demand-trend-analysis/onlineofflineanalysis/onlineofflineanalysis.component';
import { HvlvdiffreportComponent } from './reports/hvlvdiffreport/hvlvdiffreport.component';
import { FileUploadModule } from "ng2-file-upload";
import { EmsComponent } from './ems/ems.component';
import { EnergymeterManagerComponent } from './energymeter-manager/energymeter-manager.component';
import { AddUpdateEnergymeterComponent } from './energymeter-manager/add-update-energymeter/add-update-energymeter.component';
import { EmsreportComponent } from './reports/emsreport/emsreport.component';
import { DashboardSelectionComponent } from './dashboard-selection/dashboard-selection.component';
import { PopuptableComponent } from './popuptable/popuptable.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AlertpopuptableComponent } from './alertpopuptable/alertpopuptable.component';
import { SimreportComponent } from './reports/simreport/simreport.component';
import { EmsalerttabledialogComponent } from './emsalerttabledialog/emsalerttabledialog.component';
import { DatePipe } from '@angular/common';
import { EmsIndividualDashboardComponent } from './ems-individual-dashboard/ems-individual-dashboard.component';
import { EmstreeComponent } from './emstree/emstree.component';
import { EmsalertreportComponent } from './emsalertreport/emsalertreport.component';
import { RenewalWindowComponent } from './renewal-window/renewal-window.component';
import { OfflinepaymentComponent } from './renewal-window/offlinepayment/offlinepayment.component';
import { ForgotpasswordComponent } from './login/forgotpassword/forgotpassword.component';
import { MqttdashboardComponent } from './mqttdashboard/mqttdashboard.component';
import { DetectionReportComponent } from './reports/detection-report/detection-report.component';
import { PumpdashboardComponent } from './pumpdashboard/pumpdashboard.component';
import { PumpmanagerComponent } from './pumpmanager/pumpmanager.component';
import { PumppopuptableComponent } from './pumppopuptable/pumppopuptable.component';
import { PumpaddeditComponent } from './pumpmanager/pumpaddedit/pumpaddedit.component';
import { PumpgatewayreportComponent } from './reports/pumpgatewayreport/pumpgatewayreport.component';
import { PumpalertreportComponent } from './reports/pumpalertreport/pumpalertreport.component';
import { PumpindividualComponent } from './pumpindividual/pumpindividual.component';
import { TransformeranalyticsComponent } from './transformeranalytics/transformeranalytics.component';
import { FeederdashboardComponent } from './feeder/feederdashboard/feederdashboard.component';
import { FeederReportsComponent } from './feeder/feeder-reports/feeder-reports.component';
import { FeederpopupComponent } from './feeder/feederpopup/feederpopup.component';
import { FeedermanagerComponent } from './feeder/feedermanager/feedermanager.component';
import { AddUpdateFeederComponent } from './feeder/feedermanager/add-update-feeder/add-update-feeder.component';
import { ManagerComponent } from './feeder/manager/manager.component';
import { TransformermaintainanceComponent } from './transformermaintainance/transformermaintainance.component';
import { MaintainanceplanningComponent } from './transformermaintainance/maintainanceplanning/maintainanceplanning.component';
import { EmspopuptableComponent } from './ems/emspopuptable/emspopuptable.component';
import { JourgemachinedashboardComponent } from './jourgemachinedashboard/jourgemachinedashboard.component';
import { JourgemachineService } from './services/jourgemachine.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MaintainanceComponent } from './transformermaintainance/maintainance/maintainance.component';
import { AddresolutionComponent } from './transformermaintainance/addresolution/addresolution.component';
import { DigitaltwinComponent } from './individual-dashboard/digitaltwin/digitaltwin.component';
import { SolardashboardComponent } from './solarDashboard/solardashboard/solardashboard.component';
import { SolarManagerComponent } from './solarDashboard/solar-manager/solar-manager.component';
import { AddupdatesolarmanagerComponent } from './solarDashboard/solar-manager/addupdatesolarmanager/addupdatesolarmanager.component';
import { AnnunciatorComponent } from './annunciator/annunciator.component';
import { RealTimeGraphsComponent } from './individual-dashboard/real-time-graphs/real-time-graphs.component';
import { LiveTableComponent } from './individual-dashboard/live-table/live-table.component';

PlotlyModule.plotlyjs = PlotlyJS;
const appearance: MatFormFieldDefaultOptions = {
  appearance: 'outline'
};

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    SideNavComponent,
    IndividualDashboardComponent,
    UserComponent,
    AddEditUserComponent,
    SiteManagerComponent,
    AddEditSiteManagerComponent,
    DemandTrendAnalysisComponent,
    DemandTrendAnalysisAvailabilityComponent,
    ConfirmationDailogComponent,
    TransfomerManagerComponent,
    AddTransformerComponent,
  DeviceManagerComponent,
  AddDeviceComponent,
  ReportComponent,
  AlertReportComponent,
CustomDateComponent,
AlertComponent,
AccessDeniedComponent,
OnlineofflinereportComponent,
OnlineofflineanalysisComponent,
HvlvdiffreportComponent,
EmsComponent,
EnergymeterManagerComponent,
AddUpdateEnergymeterComponent,
EmsreportComponent,
DashboardSelectionComponent,
PopuptableComponent,
AlertpopuptableComponent,
SimreportComponent,
EmsalerttabledialogComponent,
EmsIndividualDashboardComponent,
EmstreeComponent,
EmsalertreportComponent,
RenewalWindowComponent,
OfflinepaymentComponent,ForgotpasswordComponent,MqttdashboardComponent, DetectionReportComponent, PumpdashboardComponent, PumpmanagerComponent, PumppopuptableComponent, PumpaddeditComponent, PumpgatewayreportComponent, PumpalertreportComponent, PumpindividualComponent, TransformeranalyticsComponent, FeederdashboardComponent, FeederReportsComponent, FeederpopupComponent, FeedermanagerComponent, AddUpdateFeederComponent, ManagerComponent, TransformermaintainanceComponent, MaintainanceplanningComponent, EmspopuptableComponent, JourgemachinedashboardComponent, MaintainanceComponent, AddresolutionComponent, DigitaltwinComponent, SolardashboardComponent, SolarManagerComponent, AddupdatesolarmanagerComponent, AnnunciatorComponent, RealTimeGraphsComponent, LiveTableComponent  ],
  imports: [
    BrowserModule,
    CircularGaugeModule,
    GaugeChartModule,
    AppRoutingModule,
    MaterialModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgSelectModule,
    FormsModule,
    PlotlyModule,
    FileUploadModule,
    NgxUiLoaderModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatTooltipModule,
    MatProgressBarModule,
    MatTooltipModule,
    ToastrModule.forRoot({
      timeOut: 4500,
      preventDuplicates: false
    }),
    AgmCoreModule.forRoot({
      apiKey:'AIzaSyA2DzpDvUIVQBLl2co_oq0G5VWAYEwMLHU'   /*'AIzaSyD2o884PpkCaqTGhJxbEqdL8Q7O2Bh6KEs' 'AIzaSyAPySGROwj9kE2OmvGNVLLy0qGmTmyKzMU'/* 'AIzaSyCKUJQ_V-tWsf7OH2d9LKPCDJGkOAWSG8g' */
    })
  ],
  providers: [
    DashboardService,
    SseService,
    GradientService,
    LoginService,
    GlobalService,
    SiteManagerService,
    DeviceMasterService,
    AuthGuard,
    AccessAuthGuard,
    NgxUiLoaderService,
    ReportService,
    DatePipe,
    JourgemachineService,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
  entryComponents: [AddEditUserComponent,AddEditSiteManagerComponent, AddTransformerComponent, AddDeviceComponent, ConfirmationDailogComponent, CustomDateComponent, AlertComponent,AddUpdateEnergymeterComponent,PumppopuptableComponent,PopuptableComponent,AlertpopuptableComponent,EmsalerttabledialogComponent,RenewalWindowComponent,OfflinepaymentComponent,ForgotpasswordComponent,PumpaddeditComponent,FeederReportsComponent,FeederpopupComponent,FeedermanagerComponent,AddUpdateFeederComponent,ManagerComponent,TransformermaintainanceComponent,EmspopuptableComponent,AddresolutionComponent,AddupdatesolarmanagerComponent]
})
export class AppModule { }
